/*
 * @Author: Src
 * @Date: 2025-05-21 09:31:06
 * @LastEditTime: 2025-05-21 17:07:44
 * @LastEditors: Src
 * @FilePath: /work-station/src/store/modules/permission.ts
 * @Description: 权限模块
 */
import { Module } from 'vuex';
import { RootState } from '../types';

// 定义模块的 State 类型
export interface PermissionState {
  permission: string[];
}

const permissionModule: Module<PermissionState, RootState> = {
  namespaced: true,
  state: {
    permission: [],
  },
  mutations: {
    SET_PERMISSION(state: PermissionState, payload: string[]) {
      state.permission = payload;
    },
  },
  actions: {
    updatePermission({ commit }, permission: string[]) {
      commit('SET_PERMISSION', permission);
    },
  },
  getters: {
    permission(state) {
      return state.permission;
    },
  },
};

export default permissionModule;
